export const spacing = {
  none: '0px',
  xxs: '2px',
  xs: '4px',
  sm: '8px',
  md: '12px',
  base: '16px',
  lg: '20px',
  xl: '24px',
  xxl: '32px',
  xxxl: '48px',
  xxxxl: '64px',
};

export const fontSizes = {
  xxs: '10px',
  xs: '12px',
  sm: '14px',
  base: '16px',
  md: '17px',
  lg: '18px',
  xl: '20px',
  xxl: '24px',
  xxxl: '32px',
  display: '36px',
};

export const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

// Estilo X/Twitter: cantos minimos. Antes esses valores eram 50-100%
// mais altos (16/12/8) e dava um look mais "soft/consumer". Pra contexto
// CCO de monitoramento, a leitura ganha com cantos mais retos —
// boundaries ficam mais nitidas, info-density sobe. Pill mantida pra
// chips/badges que ainda fazem sentido redondos.
export const radii = {
  none: '0',
  sm: '3px',
  base: '6px',
  md: '8px',
  lg: '10px',
  pill: '999px',
};

// Breakpoints consolidados — antes a codebase tinha 30+ valores diferentes
// espalhados (600, 720, 802, 822, 844, 850, 870, 900, 950, 980, 1000,
// 1050, 1100, 1180, 1250, 1280, 1285, 1300, 1350, 1450, 1485, 1550, 1585,
// 1700, 1705...) — basicamente cada dev inventou uma. Para um app de
// monitoramento em CCO, os tamanhos relevantes sao:
//
//   mobile      < 720   : raro, operadores usam desktops grandes
//   tablet      < 1024  : ocasional (laptops pequenos, tablets)
//   laptop      < 1366  : padrao notebook corporativo
//   desktop     < 1600  : monitor 1080p
//   wide       >= 1600  : monitor 2K/4K (CCO comum)
//
// Use os tokens canonicos (mobile/tablet/laptopLg/desktop/wide) em codigo
// novo. Os aliases originais (laptop=1240, desktop=1325) ficam aqui para
// nao quebrar styled-components ja em producao — refatoracao gradual.
export const breakpoints = {
  // Sistema canonico (use estes em codigo novo)
  mobile: '720px',
  tablet: '1024px',
  laptopLg: '1366px',
  desktopLg: '1600px',
  wide: '1920px',

  // Aliases shadcn-style (sm/md/lg/xl)
  sm: '720px',
  md: '1024px',
  lg: '1366px',
  xl: '1600px',
  xxl: '1920px',

  // Aliases legados em uso no codigo (NAO REMOVER sem refatorar consumers).
  // Idealmente migrar para os canonicos acima ao longo do tempo.
  laptop: '1240px',
  desktop: '1325px',
  tabletLg: '820px',
  tabletWide: '945px',
};

// Helper de media queries. Aceita uma chave do breakpoints OU um valor
// em px direto (string ou number).
//
// Exemplos:
//   ${media.down('tablet')} { ... }      // @media (max-width: 1024px)
//   ${media.up('desktop')} { ... }       // @media (min-width: 1600px)
//   ${media.raw(1325, 'max')} { ... }    // @media (max-width: 1325px)
export const media = {
  up: (bp) => `@media (min-width: ${breakpoints[bp] || bp})`,
  down: (bp) => `@media (max-width: ${breakpoints[bp] || bp})`,
  raw: (px, type = 'max') => `@media (${type}-width: ${px}px)`,
};

// X-style: praticamente sem shadow. Cards usam borda 1px pra separar
// do fundo em vez de drop shadow. lg reservado pra popovers/modais que
// precisam destacar de elementos abaixo.
export const shadows = {
  sm: 'none',
  base: 'none',
  lg: '0 4px 14px rgba(0, 0, 0, 0.18)',
};

export const transitions = {
  fast: '150ms ease',
  base: '270ms ease',
  slow: '400ms ease',
};
